import { action, observable } from "mobx";

import GpUsersApiService from "@api-services/gp-users/GpUsersApiService";
import type { RootStore } from "@state/stores/types";

class GracePeriodStore {
	@observable isActive: boolean = false;
	@observable shouldShowGracePeriodEmptyState: boolean = false;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	setShouldShowGracePeriodEmptyState(
		shouldShowGracePeriodEmptyState: boolean
	) {
		this.shouldShowGracePeriodEmptyState = shouldShowGracePeriodEmptyState;
	}

	@action.bound
	showPopup() {
		this.isActive = true;
	}

	@action.bound
	hidePopup() {
		this.isActive = false;
	}

	@action.bound
	async acceptGracePeriod() {
		try {
			await GpUsersApiService.confirmGracePeriod();

			if (this.rootStore.retryHandlerStore.retryFunction) {
				await this.rootStore.retryHandlerStore.executeRetry();
				this.setShouldShowGracePeriodEmptyState(false);
			}

			this.rootStore.retryHandlerStore.clearRetry();
		} catch (error) {
			console.error("Error confirming grace period", error);
		}
	}
}

export default GracePeriodStore;
